module.exports = __webpack_public_path__ + "img/subscribe.edbbd763.jpg";